import { render, staticRenderFns } from "./ComboboxField.vue?vue&type=template&id=4b786b23&scoped=true"
import script from "./ComboboxField.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboboxField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComboboxField.vue?vue&type=style&index=0&id=4b786b23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b786b23",
  null
  
)

export default component.exports